// Small formatting helpers for the AI screens

// A link only for http(s) URLs: traces live in message attributes, which API clients can write
export const safeUrl = url =>
  /^https?:\/\//i.test(url || '') ? url : undefined;

export const formatCost = (value, locale) =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: value > 0 && value < 1 ? 4 : 2,
  }).format(value || 0);

export const formatTokens = (value, locale) =>
  new Intl.NumberFormat(locale, { notation: 'compact' }).format(value || 0);

// A tool call of an AI answer, for people: an icon, what it was (LOCO.AI.TRACE.*) and its detail
export const describeToolCall = ({ name, arguments: args = {} }) => {
  switch (name) {
    case 'handoff':
      return {
        icon: 'i-lucide-user-round',
        key: 'HANDOFF',
        detail: args.reason,
      };
    case 'resolve':
      return { icon: 'i-lucide-circle-check', key: 'RESOLVE', detail: '' };
    case 'add_label':
      return { icon: 'i-lucide-tag', key: 'LABEL', detail: args.label };
    case 'search_knowledge':
      return { icon: 'i-lucide-search', key: 'SEARCH', detail: args.query };
    default:
      return { icon: 'i-lucide-plug', key: 'TOOL', detail: name };
  }
};

export const SOURCE_ICONS = {
  url: 'i-lucide-globe',
  file: 'i-lucide-file-text',
  text: 'i-lucide-align-left',
  faq: 'i-lucide-message-circle-question',
  help_center: 'i-lucide-book-open',
};

// The conversation a Q&A pair was learned from
export const learnedFromRoute = (accountId, source) => ({
  name: 'inbox_conversation',
  params: {
    accountId,
    conversation_id: source.settings.conversation_display_id,
  },
});

export const isSyncing = source =>
  ['pending', 'processing'].includes(source.status);
